export default __webpack_public_path__ + "static/media/sprite.2a5627fd.svg";